import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DecorativeSquares from "../../ui/DecorativeSquares";
import { FiPhoneCall } from "react-icons/fi";
import { GoSun, GoMoon } from "react-icons/go";
import { SlCalender } from "react-icons/sl";
import { CiLocationOn } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import PrimaryBtn from "../../button/PrimaryBtn";
import SecondaryBtn from "../../button/SecondaryBtn";
import orderdish from "../../../assets/images/svgs/cards/orders.svg";
import { addOrupdateCustomerOrder } from "../../../redux/thunks/orderCustomerThunk";
import toast from "react-hot-toast";
import CompleteOrderShimmer from "../../Preloader/CompleteOrderShimmer";
import { clearOrderDraft } from "../../../redux/slices/orderDraftSlice";
import { SquareArrowOutUpRight } from "lucide-react";
import MapModal from "../../Modals/MapModal";
import CheckDate from "../../Modals/CheckDate";

const CompleteSingle = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDateOpen, setIsDateOpen] = useState(false);
  const { draft } = useSelector((state) => state.orderDraft);
  console.log("location.state =>", location.state);
  const { isOrderLoading } = useSelector((state) => state.customerOrder);

  if (!draft) {
    return <p className="text-center mt-8">No order details available</p>;
  }

  const calculatePricing = (draft) => {
    const finalTotal = Number(draft.meal.price) * Number(draft.meal.qty);

    const extrasTotal =
      draft.extraItems?.reduce((acc, item) => acc + Number(item.total), 0) || 0;

    const deliveryCharge = Number(draft.pricing.deliveryCharge || 0);

    const subTotal = finalTotal + extrasTotal + deliveryCharge;

    const discount = Number(draft.pricing.discount || 0);

    const finalAmount = Math.max(subTotal - discount, 0);

    return {
      finalTotal,
      extrasTotal,
      deliveryCharge,
      discount,
      subTotal,
      finalAmount,
    };
  };

  const pricing = calculatePricing(draft);

  const buildPayload = () => {
    const basePayload = {
      service_provider_customer_id:
        draft.customer.id || draft.customer.selectedCustomerId,

      meal_id: draft.meal.id,
      meal_timing: draft.order.mealTiming,
      plan_type: "trial",
      order_date: draft.order.date,
      quantity: draft.meal.qty,
      order_amount: pricing.finalAmount,
      delivery_preference: draft.order.deliveryType,
      extra_items: draft.extra_Item || [],
      time_slot: draft.order.timeSlot,
      order_remark: draft.orderRemark,
    };

    // ✅ Only add address id if delivery selected
    if (draft.order.deliveryType === "delivery") {
      basePayload.sp_customer_address_id = draft.addressId;
    }

    return basePayload;
  };

  const handleGoBack = () => {
    const payload = buildPayload();
    console.log("The payload data to be checked is :", payload);

    dispatch(addOrupdateCustomerOrder(payload))
      .unwrap()
      .then((res) => {
        if (!res.success) {
          toast.error(res.message);
          return;
        }
        toast.success(res.message || "Meal Ordered");
        dispatch(clearOrderDraft());
        navigate("/customer");
      })
      .catch((err) => {
        toast.error(err || "Something went wrong");
      });
  };

  const handleNext = () => {
    const payload = buildPayload();
    const checkDate = draft?.order?.date;
    const selectedDate = new Date(checkDate);
    const today = new Date();
    // Remove time part for proper comparison
    selectedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    // 🚫 If future date
    if (selectedDate > today) {
      setIsDateOpen(true);
      return;
    }

    dispatch(addOrupdateCustomerOrder(payload))
      .unwrap()
      .then((res) => {
        if (!res.success) {
          toast.error(res.message);
          return;
        }

        const orderId = res?.data?.order_id;
        toast.success(res.message || "Meal Ordered");

        dispatch(clearOrderDraft());

        navigate("/single-order", {
          state: { orderId },
        });
      })
      .catch((err) => {
        toast.error(err || "Something went wrong");
      });
  };

  const address = draft.address;

  const handleOpenMap = () => {
    if (!address?.latitude || !address?.longitude) return;

    const lat = address.latitude;
    const lng = address.longitude;

    const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;

    window.open(mapUrl, "_blank");
  };

  const formattedDate = new Date(draft?.order?.date).toLocaleDateString(
    "en-US",
    {
      month: "short",
      day: "2-digit",
      year: "numeric",
    },
  );

  return (
    <>
      <section className="relative min-h-screen bg-slate-50">
        <DecorativeSquares />
        {isOrderLoading ? (
          <CompleteOrderShimmer />
        ) : (
          <>
            {/* Customer Card */}
            <div className="mt-8 mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-2 shadow-sm flex items-center gap-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                {draft.customer.initials}
              </div>
              <div className="flex flex-col">
                <h2 className="text-base font-semibold text-gray-900">
                  {draft.customer.name}
                </h2>
                <p className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                  <FiPhoneCall /> {draft.customer.phone}
                </p>
              </div>
            </div>

            {/* Meal Details */}
            <div className="mt-8 mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
              <div className="flex items-center gap-4">
                <div className="flex items-center justify-center rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                  <img
                    src={draft.meal.image}
                    alt={draft.meal.name}
                    className="object-cover w-12 h-12 rounded-md"
                  />
                </div>
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {draft.meal.name}
                  </h2>
                  <p className="mt-1 flex items-center gap-2 text-sm text-[#FF6943] font-bold">
                    {draft.cSymbol}
                    {draft.meal.price}
                  </p>
                </div>
              </div>

              {/* Timing and Date */}
              <div className="mt-4 flex justify-start gap-4">
                <div className="rounded-full bg-[#ACA8A6]/30 w-24 p-1 px-2 flex justify-center gap-2">
                  {draft.order.mealTiming === "Lunch" ? (
                    <GoSun size={12} />
                  ) : (
                    <GoMoon size={12} />
                  )}
                  <p className="text-xs">{draft.order.mealTiming}</p>
                </div>
                <div className="mt-1 flex justify-center gap-2">
                  <SlCalender size={12} />
                  <p className="text-xs">{draft.order.date}</p>
                </div>
              </div>

              <div className="border-b border-gray-200 mt-6 mb-2"></div>

              {/* Order Summary */}
              <div className="mt-4">
                <div className="flex justify-between gap-4">
                  <div className="flex gap-4">
                    <img src={orderdish} alt="orderDish" className="h-5 w-5" />
                    <p className="text-gray-700 text-sm">{draft.meal.qty}</p>
                  </div>
                  <p className="mt-1 flex items-center gap-2 text-sm text-[#FF6943] font-bold">
                    {draft.cSymbol}
                    {Number(draft.pricing.mealTotal).toFixed(2)}
                  </p>
                </div>

                {/* Extra Items Section */}

                <div className="relative -mx-4 sm:mx-0 overflow-x-auto lg:overflow-x-hidden mt-4">
                  <div className="w-full md:min-w-[640px] rounded-lg border border-gray-200 bg-white">
                    <table className="w-full text-left text-sm sm:text-base text-gray-800">
                      <thead className="bg-gray-50">
                        {draft.extraItems?.length > 0 && (
                          <tr>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-start text-base sm:text-lg font-semibold"
                            >
                              Extra items
                            </th>
                            <th
                              colSpan={2}
                              className="py-3 px-4 text-end text-base sm:text-lg font-semibold text-[#FF6943]"
                            >
                              {draft.cSymbol}
                              {Number(
                                draft.extraItems.reduce(
                                  (acc, i) => acc + i.total,
                                  0,
                                ),
                              ).toFixed(2)}
                            </th>
                          </tr>
                        )}
                      </thead>

                      <tbody className="divide-y">
                        {draft.extraItems?.length > 0 &&
                          draft.extraItems.map((item, i) => (
                            <tr key={i}>
                              <td colSpan={2} className="py-2 px-4">
                                <div className="flex items-center gap-2 whitespace-nowrap">
                                  <span className="inline-block w-2 h-2 rounded-full bg-[#FF6943]" />
                                  <span>{`${item.qty} x ${item.name}`}</span>
                                </div>
                              </td>
                              <td className="py-2 px-4 text-end font-semibold whitespace-nowrap">
                                {draft.cSymbol}
                                {Number(item.amount).toFixed(2)}
                              </td>
                            </tr>
                          ))}

                        {/* Charges */}
                        {draft?.order?.deliveryType === "delivery" && (
                          <tr className="bg-gray-50">
                            <th colSpan={2} className="py-3 px-4 font-semibold">
                              Delivery charges
                            </th>
                            <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                              {draft.cSymbol}
                              {Number(pricing.deliveryCharge).toFixed(2)}
                            </th>
                          </tr>
                        )}

                        {(() => {
                          const rawValue = Number(pricing.discount || 0);
                          if (rawValue === 0) return null;
                          const isDiscount = rawValue < 0;

                          return (
                            <tr>
                              <th
                                colSpan={2}
                                className="py-3 px-4 font-semibold"
                              >
                                {isDiscount ? "Discount" : "Other Charges"}
                              </th>

                              <th
                                className={`py-3 px-4 text-end font-semibold ${
                                  isDiscount ? "text-[#1CCB50]" : "text-red-500"
                                }`}
                              >
                                {isDiscount
                                  ? `- ${draft.cSymbol}`
                                  : `+${draft.cSymbol}`}
                                {Math.abs(rawValue).toFixed(2)}
                              </th>
                            </tr>
                          );
                        })()}

                        <tr className="bg-orange-50">
                          <th
                            colSpan={2}
                            className="py-3 px-4 font-semibold text-[#FF6943]"
                          >
                            Total Order Amount
                          </th>
                          <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                            {draft.cSymbol}
                            {Number(pricing.finalAmount).toFixed(2)}
                          </th>
                        </tr>
                      </tbody>

                      <tfoot className="border-t bg-white">
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Plan Type
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {draft.order.planType}
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Start Date
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {draft.order.date}
                          </th>
                        </tr>
                        <tr>
                          <th
                            colSpan={2}
                            className="py-3 px-4 font-medium text-left"
                          >
                            Meal Timing
                          </th>

                          <th colSpan={2} className="py-3 px-4 text-end">
                            <div className="flex justify-end">
                              <div className="inline-flex items-center gap-2 rounded-full bg-[#ACA8A6]/30 px-3 py-1 text-sm font-semibold capitalize">
                                {draft?.order?.mealTiming === "lunch" ? (
                                  <GoSun size={14} />
                                ) : (
                                  <GoMoon size={14} />
                                )}

                                <span>{draft?.order?.mealTiming || "-"}</span>
                              </div>
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Delivery Type
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {draft.order.deliveryType === "delivery"
                              ? "Home Delivery"
                              : "Pick up"}
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={2} className="py-3 px-4 font-medium">
                            Time slot
                          </th>
                          <th
                            colSpan={2}
                            className="py-3 px-4 text-end font-semibold"
                          >
                            {draft.order.timeSlot}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  {/* Order remark */}
                  {draft.orderRemark && (
                    <div className="mt-8 mb-4 mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-2 shadow-sm flex items-center gap-4">
                      <div className="flex flex-col p-4">
                        <div className="mb-2">
                          <h1 className="text-base font-bold text-black">
                            Order Remark
                          </h1>
                        </div>
                        <div className="mb-2 text-sm text-gray-400">
                          {draft.orderRemark}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Address */}
                {draft.address && (
                  <div className="mt-4 flex justify-start gap-2 cursor-pointer">
                    <CiLocationOn size={20} className="text-[#363636]" />
                    <p className="text-start text-[#363636] text-[12px] md:text-sm">
                      {draft.address.fullAddress}
                    </p>
                  </div>
                )}
              </div>

              <div className="flex justify-center flex-col md:flex-row gap-4 md:justify-between mt-4">
                <PrimaryBtn
                  btnName="Deliver later"
                  clickEvent={handleGoBack}
                  isLoading={isOrderLoading}
                />
                <SecondaryBtn
                  btnName="Deliver Now"
                  clickEvent={handleNext}
                  isLoading={isOrderLoading}
                />
              </div>
            </div>
          </>
        )}
      </section>
      <CheckDate
        open={isDateOpen}
        onClose={() => setIsDateOpen(false)}
        date={formattedDate}
      />
    </>
  );
};

export default CompleteSingle;
